export function parseTooltipHtml(html: string): string {
  const tooltipHtml = String(html).replace(/\{\{tt:([\s\S]*?)\}\}/g, (_match, inner: string) => {
    const parts = inner.split('|');
    const display = parts.shift() ?? '';
    const rows = parts
      .map(part => {
        const idx = part.indexOf(':');
        if (idx === -1) {
          return `<div>${part.trim()}</div>`;
        }
        const label = part.slice(0, idx).trim();
        const value = part.slice(idx + 1).trim();
        return `<div><span class="lbl">${label}</span> ${value}</div>`;
      })
      .join('');

    return `<span class="tt" tabindex="0">${display}<span class="tt-body" role="tooltip">${rows}</span></span>`;
  });

  return tooltipHtml
    .split(/(<[^>]+>)/g)
    .map(part => part.startsWith('<')
      ? part
      : part.replace(/\b[A-Z0-9]+(?:_[A-Z0-9]+){2,}\b/g, '<span class="domain-identifier">$&</span>'))
    .join('');
}
